import Link from "next/link";
import React, { memo } from "react";
import { tuple } from "@/read-ui/_util/type";

import Button from "@/read-ui/Button";
import InputBox from "@/read-ui/InputBox";
import { useRouter } from "next/router";
import { openApp } from "@/utils/appManager";
import { AF_ADSET } from "@/utils/appManager";
import styles from "./styles.module.scss";
import IntersectionObserver from "../../IntersectionObserver";
import { toDomProps } from "../../QDReport";

const HeaderLogoSize = tuple("small", "auto");
interface HeaderProps extends React.HTMLAttributes<HTMLHeadElement> {
  search?: boolean;
  isFixed?: boolean;
  children?: React.ReactNode;
  logoSize?: typeof HeaderLogoSize[number];
}

const Header = ({
  isFixed = true,
  children,
  className = "",
  logoSize = "auto",
  search,
}: HeaderProps) => {
  const router = useRouter();
  const handleClick = async () => {
    openApp({ router, afQuery: { af_adset: AF_ADSET.header_download } });
  };

  const downloadReport = {
    uiname: "topdownload",
    dl: 1,
  };
  return (
    <>
      <header
        className={`w100% df h48 bc_fff aic jcc ${styles.header} ${
          isFixed ? "pf t0 l0" : "pr"
        } ${className}`}
      >
        <div className={`g_wrap df aic w100% ${styles.headerInner}`}>
          <Link
            href="/?refer=header"
            rel="nofollow"
            className={`w32 h32 dib mr16 ${styles.logo} _${logoSize}`}
            title="Webnovel"
          >
            <span className={"dn"}>Chereads</span>
          </Link>
          <div className={"f1 mr16"}>
            {search && (
              <InputBox
                className={"ff_sans fs14 fw400"}
                size="sm"
                placeholder="Search"
              />
            )}
          </div>
          <IntersectionObserver
            Component={Button}
            size={"xs"}
            onClick={handleClick}
            report={downloadReport}
            {...toDomProps(downloadReport)}
          >
            <span className="ff_sans fs12 lh16 fw700 ls1">DOWNLOAD APP</span>
          </IntersectionObserver>
        </div>
      </header>
      {isFixed && <div className={`db h48`} />}
      {children}
    </>
  );
};

export default memo(Header);
